import api from "./api";

class StatoManager {

    stati(config?: any) {
        return api.get(`/stati`, config)
    }

    stato(id: number | string, config?: any) {
        return api.get(`/stati/${id}`, config)
    }

    retrieve = this.stato
    list = this.stati
    paginatedList = this.stati
}

const statoManager = new StatoManager()

export default statoManager
